export default {
  ExtraSmall: 525,
  Small: 767,
  Medium: 1023,
  Large: 1200
};
